// ISO-2 to flag emoji helper
export function flag(iso2) {
  if (!iso2 || iso2.length !== 2) return "🌐";
  // Generic regions have no flag; map them.
  const special = { EU: "🇪🇺", GL: "🌍" };
  if (special[iso2]) return special[iso2];
  const code = iso2.toUpperCase();
  return String.fromCodePoint(...[...code].map((c) => 127397 + c.charCodeAt(0)));
}

export function fmtData(mb) {
  if (!mb) return "0";
  if (mb >= 500000) return "∞";
  if (mb >= 1024) return `${(mb / 1024).toFixed(mb % 1024 === 0 ? 0 : 1)} GB`;
  return `${mb} MB`;
}

export function fmtEUR(n) {
  return `€${Number(n || 0).toFixed(2)}`;
}

export function fmtDate(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return s;
  }
}

/** Localized country name for an ISO-3166 alpha-2 code using the browser's
 *  built-in CLDR data. Falls back to the original `fallback` (typically the
 *  English name from the backend) for regional bundles like `EU`, `GL`. */
const REGION_FALLBACK = {
  en: { EU: "Europe", GL: "Global" },
  tr: { EU: "Avrupa", GL: "Global" },
  fr: { EU: "Europe", GL: "Monde" },
  de: { EU: "Europa", GL: "Global" },
  es: { EU: "Europa", GL: "Global" },
  el: { EU: "Ευρώπη", GL: "Παγκόσμιο" },
  ar: { EU: "أوروبا", GL: "عالمي" },
  zh: { EU: "欧洲", GL: "全球" },
  ja: { EU: "ヨーロッパ", GL: "グローバル" },
};

export function countryName(iso2, lang, fallback) {
  const code = (iso2 || "").toUpperCase();
  if (!code) return fallback || "";
  const lg = (lang || "en").toLowerCase();
  const override = REGION_FALLBACK[lg] && REGION_FALLBACK[lg][code];
  if (override) return override;
  try {
    const dn = new Intl.DisplayNames([lg], { type: "region" });
    const out = dn.of(code);
    if (out && out !== code) return out;
  } catch {}
  return fallback || code;
}
